import React from 'react';
import IslamicPatternMaker from './IslamicPatternMaker';
import './App.css';

function App() {
  return <IslamicPatternMaker />;
}

export default App;
